import React, { useEffect, useState } from "react";
import { useHeading } from "../admin/HeadingContext"; // Import the HeadingContext
import "./Navbar.css";
import { useLocation, Link } from "react-router-dom";

const Navbar = () => {
  const { heading } = useHeading(); // Access the global heading
  const [isOpen, setIsOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isNewPatientsDropdownOpen, setIsNewPatientsDropdownOpen] =
    useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const loc = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, 
      // behavior: "smooth" 
    });
     setIsNewPatientsDropdownOpen(false);
     setIsAboutDropdownOpen(false);
     setIsServicesDropdownOpen(false);
    setIsOpen(false);
  }, [loc.pathname]);
  const toggleAboutDropdown = () => {
    setIsAboutDropdownOpen(!isAboutDropdownOpen);
    setIsServicesDropdownOpen(false);
    setIsNewPatientsDropdownOpen(false);
  };

  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
    setIsAboutDropdownOpen(false);
    setIsNewPatientsDropdownOpen(false);
  };

  const toggleNewPatientsDropdown = () => {
    setIsNewPatientsDropdownOpen(!isNewPatientsDropdownOpen);
    setIsAboutDropdownOpen(false);
    setIsServicesDropdownOpen(false);
  };

  return (
    <>
      {/* Display the global heading */}
      <div className="top-bar">
        <span>
          {heading ? (
            <>
              {heading} <Link to="/booknow">Book Now!</Link>
            </>
          ) : (
            "Loading..." // Placeholder while fetching
          )}
        </span>
      </div>

      <header className="header">
        <Link to="/" className="logo-link">
          <div className="logo"></div>
        </Link>

        <nav className={`nav-links ${isOpen ? "show" : ""}`}>
          {/* About Section */}
          <div
            className="nav-item"
            onClick={toggleAboutDropdown}
            onMouseEnter={() => setIsAboutDropdownOpen(true)}
            onMouseLeave={() => setIsAboutDropdownOpen(false)}
          >
            <Link to="#about">ABOUT</Link>
            <ul
              className={`dropdown-menu ${isAboutDropdownOpen ? "show" : ""}`}
            >
              <li>
                <Link to="/meet-the-doctors">Meet the Doctors</Link>
              </li>
              <li>
                <Link to="/beforeafter">Before and Afters</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/dentaltech">Dental Technology</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
            </ul>
          </div>

          {/* Services Section */}
          <div
            className="nav-item"
            onClick={toggleServicesDropdown}
            onMouseEnter={() => setIsServicesDropdownOpen(true)}
            onMouseLeave={() => setIsServicesDropdownOpen(false)}
          >
            <Link to="#service">SERVICES</Link>
            <ul
              className={`dropdown-menu ${
                isServicesDropdownOpen ? "show" : ""
              }`}
            >
              <li>
                <Link to="/problem">Problems we treat</Link>
              </li>
              <li>
                <Link to="/invisalign">Invisalign</Link>
              </li>
              <li>
                <Link to="/braces">Braces (Orthodontics)</Link>
              </li>
              <li>
                <Link to="/surgical">Surgical</Link>
              </li>
            </ul>
          </div>

          {/* New Patients Section */}
          <div
            className="nav-item"
            onClick={toggleNewPatientsDropdown}
            onMouseEnter={() => setIsNewPatientsDropdownOpen(true)}
            onMouseLeave={() => setIsNewPatientsDropdownOpen(false)}
          >
            <Link to="#newpatient">NEW PATIENTS</Link>
            <ul
              className={`new-patients-dropdown-menu  ${
                isNewPatientsDropdownOpen ? "show" : ""
              }`}
            >
              <li>
                <Link to="/newpatient">Payment Options</Link>
              </li>
              <li>
                <Link to="/patientcomfort">Patient Comfort</Link>
              </li>
              <li>
                <Link to="/freeconsultation">Free Consultation</Link>
              </li>
            </ul>
          </div>

          <Link to="tel:+918882672980">088826 72980</Link>
          <Link to="/booknow" className="book-online-button">
            BOOK ONLINE
          </Link>
        </nav>

        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
